/* eslint-disable */
import {
  Box,
  Button,
  Container,
  Divider,
  Group,
  Stack,
  Title,
} from "@mantine/core";
import React, { useState } from "react";
import HeaderCard from "./components/HeaderCard";
import DefinitionsCard from "./components/DefinitionsCard";
import CollectingDataCard from "./components/CollectingDataCard";
import UseOfDataCard from "./components/UseOfDataCard";
import RetentionCard from "./components/RetentionCard";
import LocationAccessCard from "./components/LocationAccessCard";
import ContactCard from "./components/ContactCard";
import SecurityCard from "./components/SecurityCard";
import ChildrensPrivacyCard from "./components/ChildrensPrivacyCard";
import LinksToOtherWebsitesCard from "./components/LinksToOtherWebsitesCard";
import ChangesPolicyCard from "./components/ChangesPolicyCard";
import InformationCollectedCard from "./components/informationcollectionapplication";
import TransferOfPersonalDataCard from "./components/TransferOfPersonalDataCard";
import DeletePersonalDataCard from "./components/DeletePersonalDataCard";
import LawEnforcementCard from "./components/LawEnforcementCard";
import OtherLegalRequirementsCard from "./components/OtherLegalRequirementsCard";
import DisclosureOfPersonalDataCard from "./components/DisclosureOfPersonalDataCard";

export default function PrivacyPolicy() {
  const [opened, setOpened] = useState(false);
  return (
    <Box>
      <Container size="xl" py="xl">
        <Stack>
          <HeaderCard />
          <DefinitionsCard />
          <CollectingDataCard />
          <InformationCollectedCard />
          <UseOfDataCard />
          <RetentionCard />
          <TransferOfPersonalDataCard />
          <DeletePersonalDataCard />
          <DisclosureOfPersonalDataCard />
          <LocationAccessCard />
          <LawEnforcementCard />
          <OtherLegalRequirementsCard />
          <SecurityCard />
          <ChildrensPrivacyCard />
          <LinksToOtherWebsitesCard />
          <ChangesPolicyCard />
          <ContactCard />
        </Stack>
      </Container>
    </Box>
  );
}
